<div class="toolbar flex items-center w-full">
  <div class="flex items-center h-full">
    <a
      class="logo cursor-pointer flex ml-1 outline-none focus:outline-none"
      tabindex="-1"
      routerLink="/"
      (click)="reloadPage()"
    >
      <img
        alt="logo"
        height="30"
        src="/assets/icons/logo.svg"
        width="30"
        tabindex="-1"
      />

      @if (applicationName()) {
        <span class="logo-title">{{ applicationName() }}</span>
      }
    </a>
  </div>

  <div class="toolbar-main-menu">
    <app-toolbar-menu [slug]="slug()"></app-toolbar-menu>
  </div>

  @if (user()) {
    <div class="toolbar-lang-wrapper flex h-full items-center">
      <hard-menu
        [placement]="['bottom-right', 'top-right']"
        [open]="isLangMenuOpen()"
        (openMenu)="onLangMenuOpenChange($event)"
      >
        <button
          type="button"
          class="toolbar-lang-trigger flex items-center h-[48px]"
        >
          <span>{{ currentLangShortName() }}</span>
          <span class="icon-arrow toolbar-lang-arrow"></span>
        </button>

        <div hardMenu>
          @for (lang of languages; track lang.lang) {
            <div
              class="hard-menu-row toolbar-lang-row"
              [class.active]="lang.lang === currentLang()"
              (click)="selectLanguage(lang.lang)"
            >
              {{ lang.shortName }}
            </div>
          }
        </div>
      </hard-menu>

      @if (isLangMenuOpen()) {
        <div
          class="toolbar-menu-backdrop"
          (click)="closeLangMenu()"
        ></div>
      }
    </div>

    <button
      type="button"
      class="toolbar-notification-btn"
      (click)="openNotificationsModal()"
      aria-label="Notifications"
    >
      <span class="icon-notifications-none"></span>
      @if (notificationCount() > 0) {
        <span class="toolbar-notification-badge">
          {{ notificationCount() }}
        </span>
      }
    </button>

    <div
      class="toolbar-user-wrapper flex h-full ml-2 items-center justify-end gap-2"
    >
      <hard-menu
        [placement]="['bottom-right', 'top-right']"
        [open]="isUserMenuOpen()"
        (openMenu)="onUserMenuOpenChange($event)"
      >
        <button
          type="button"
          class="item o_radius px-2 h-[48px] flex items-center gap-2 toolbar-user-trigger"
        >
          <div class="toolbar-user-photo">
            @if (user()?.photoPath) {
              <img
                class="toolbar-user-photo__img"
                [src]="user()?.photoPath"
                alt="user-photo"
              />
            } @else {
              <span class="icon-user"></span>
            }
          </div>

          <div class="toolbar-user-meta">
            <div class="toolbar-user-name">{{ user()?.name }}</div>
            @if (formattedRoleName()) {
              <div class="toolbar-user-role">
                {{ formattedRoleName() }}
              </div>
            }
          </div>

          <span class="icon-dots toolbar-user-dots"></span>
        </button>

        <div hardMenu>
          @if (isAdmin()) {
            <div
              class="hard-menu-row toolbar-menu-row"
              data-id="admin-panel"
              (click)="openAdminPanel()"
            >
              <span class="hard-menu-row-icon icon-settings"></span>
              {{ "base.adminPanel" | hardTranslate }}
            </div>
          }

          <div
            class="hard-menu-row toolbar-menu-row"
            data-id="guide"
            (click)="openGuide()"
          >
            <span class="hard-menu-row-icon icon-settings"></span>
            {{ "base.guide" | hardTranslate }}
          </div>

          <div
            class="hard-menu-row toolbar-menu-row"
            data-id="contact-support"
            (click)="openContactSupportModal()"
          >
            <span class="hard-menu-row-icon icon-email"></span>
            {{ "base.contactSupportTeam" | hardTranslate }}
          </div>

          <div
            class="hard-menu-row toolbar-menu-row toolbar-logout-row"
            data-id="logout"
            (click)="logout()"
          >
            <span class="hard-menu-row-icon icon-exit"></span>
            {{ "base.logout" | hardTranslate }}
          </div>
        </div>
      </hard-menu>

      @if (isUserMenuOpen()) {
        <div
          class="toolbar-menu-backdrop"
          (click)="closeUserMenu()"
        ></div>
      }
    </div>
  }

  <hard-button
    *hardPermissions="gridPermissions"
    class="item ml-1"
    (click)="openSettingsModal()"
    [disabled]="!hasGridWidget()"
  >
    <span class="icon-settings icon"></span>
  </hard-button>
</div>
